import Button from 'components/tailwind/Button'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '../../../components/tailwind/Modal'
import { Heading } from '../../../components/ui/Heading'
import { useCareersQuery } from '../../../hooks/use-careers-query'
import { useDiscover } from '../hooks/useDiscover'
import { useSelectionParams } from '../hooks/useSelectionParams'
import CareerSearchCombobox from './career/CareerSearchCombobox'
import SelectedCareersList from './career/SelectedCareersList'

export default function AddCareerModal() {
  const { t } = useTranslation()
  const { addCareerModalOpen, setAddCareerModalOpen } = useDiscover()

  const { addCareers } = useSelectionParams()
  const [selectedCareers, setSelectedCareers] = useState([])

  const { data: careers, isLoading: isLoadingCareers } = useCareersQuery({
    select: (items) => {
      return items
        .filter(({ status }) => status === 'ACTIVE')
        .filter(({ id }) => !id.includes('PRODUCT_TOUR'))
        .filter(({ archived }) => !archived)
    }
  })

  useEffect(() => {
    if (!addCareerModalOpen) {
      setSelectedCareers([])
    }
  }, [addCareerModalOpen])

  const handleCareerRemove = (careerToRemove) => {
    setSelectedCareers((prev) =>
      prev.filter((career) => career.id !== careerToRemove.id)
    )
  }

  const handleCareerAdd = (career) => {
    // Nur eine Stelle erlauben
    if (
      selectedCareers.length === 0 &&
      !selectedCareers.some((c) => c.id === career.id)
    ) {
      setSelectedCareers([...selectedCareers, career])
    }
  }

  const handleSubmit = () => {
    addCareers(selectedCareers.map((c) => c.id))
    setAddCareerModalOpen(false)
  }

  const handleModalClose = (isOpen) => {
    setAddCareerModalOpen(false)
  }

  return (
    <Modal
      open={addCareerModalOpen}
      setOpen={handleModalClose}
      borderRadius='rounded-xl'
      size='xl'
      hideCloseButton
      disableOverlayClose
    >
      <div>
        {isLoadingCareers ? (
          <div className='flex h-full items-center justify-center'>
            <p className='text-lg text-mediumGrey'>{t('common.loading')}</p>
          </div>
        ) : (
          <React.Fragment>
            <div className='flex flex-row items-center justify-between'>
              <h1 className='text-3xl font-bold'>
                {t('discover.add_career_modal.title')}
              </h1>
            </div>
            {selectedCareers.length > 0 && (
              <div className='mt-6'>
                <SelectedCareersList
                  selectedCareers={selectedCareers}
                  onCareerRemove={handleCareerRemove}
                />
              </div>
            )}
            {selectedCareers.length === 0 && (
              <div className='mt-6'>
                <Heading className={'mb-1'} level={5}>
                  {t('discover.add_career_modal.select_career')}
                </Heading>
                <p className='mb-3 text-sm text-darkGrey'>
                  {t('discover.add_career_modal.select_career_description', {
                    count: careers.length
                  })}
                </p>
                <CareerSearchCombobox
                  careers={careers}
                  selectedCareers={selectedCareers}
                  onCareerAdd={handleCareerAdd}
                  placeholder={t(
                    'discover.add_career_modal.select_career_placeholder'
                  )}
                />
              </div>
            )}

            <div className='mt-6 flex justify-end gap-3'>
              <Button.SecondaryXL
                text={t('common.cancel')}
                onClick={() => handleModalClose(false)}
              />
              <Button.PrimaryXL
                text={t('discover.add_career_modal.confirm_selection')}
                onClick={handleSubmit}
                disabled={selectedCareers.length === 0}
              />
            </div>

            {/* <CareerSuggestionsSection /> */}
          </React.Fragment>
        )}
      </div>
    </Modal>
  )
}
